import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeContractComponentCommand extends BaseCommand {
  CommandName = "ChangeContractComponent";
  Command: { Value: number };
  constructor(sessionId: string, operationId: string, value: number) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
